import styled from 'styled-components';

const Anchor = styled.a`
    cursor: pointer;
`;

Anchor.displayName = 'Anchor';

export { Anchor };
